import { createFileRoute } from "@tanstack/react-router"
import { OrganizationOnboardingWizardPage } from "@/pages"

export const Route = createFileRoute(
  "/_authenticated/_organizations/organizations/create"
)({
  component: OrganizationOnboardingWizardPage,
})
